

export const validar = {

    _email(email) {

        let usuario = email.substring(0, email.indexOf("@"));
        let dominio = email.substring(email.indexOf("@") + 1, email.length);

        if ((usuario.length >= 1) &&
            (dominio.length >= 3) &&
            (usuario.search("@") === -1) &&
            (dominio.search("@") === -1) &&
            (usuario.search(" ") === -1) &&
            (dominio.search(" ") === -1) &&
            (dominio.search(".") !== -1) &&
            (dominio.indexOf(".") >= 1) &&
            (dominio.lastIndexOf(".") < dominio.length - 1)) {
            return { valido: true, email: email }
        }

        return { valido: false, email: email }
    },



    _cartaodata(dataentrada) {


        var patternData = /^[0-9]{2}\/[0-9]{4}$/;
        if (patternData.test(dataentrada))

            return { valido: true, vencimento: dataentrada }

        return { valido: false, vencimento: dataentrada }

    }
    ,



    _requerido(campo) {
        if (campo.length > 0) {

            return { valido: true, campo: campo }
        }
        return { valido: false, campo: campo }
    },






}
